
/* ---------------------------- */
/* ###### IMAGES DROPBOX ###### */
/* ---------------------------- */

let image_mimes = ['image/jpeg', 'image/jpg', 'image/png']
// ************************ Drag and drop ***************** //
let dropArea = document.getElementById("images-drop-area");

if (dropArea) {

    
    let drop_file_input = dropArea.querySelector("#drop-file-input");
    var tmp_upload_id = 0;
    var files = [];
    // Prevent default drag behaviors
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, preventDefaults, false)
        document.body.addEventListener(eventName, preventDefaults, false)
    });

    // Highlight drop area when item is dragged over it
    ['dragenter', 'dragover'].forEach(eventName => {
        dropArea.addEventListener(eventName, highlight, false)
    });

    ['dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, unhighlight, false)
    });

    // Handle dropped files
    dropArea.addEventListener('drop', handleDrop, false)
    drop_file_input.addEventListener('change', function(e) {
        handleFiles(this.files)
    }, false)

    function preventDefaults(e) {
        e.preventDefault()
        e.stopPropagation()
    }

    function highlight(e) {
        dropArea.classList.add('highlight')
    }

    function unhighlight(e) {
        dropArea.classList.remove('highlight')
    }

    function handleDrop(e) {
        var dt = e.dataTransfer
        var files = dt.files
        handleFiles(files)
    }

    function handleFiles(files) {
        files = [...files]
        files.forEach(insertFile)
        document.getElementById("drop-file-input").value = "";
    }

    function insertFile(file, i) {
        let reader = new FileReader()
        if (image_mimes.includes(file.type)) {
            reader.readAsDataURL(file)
            reader.onloadend = function () {
                
                imageExists(reader.result, function () {
                    tmp_upload_id += 1;
                    let in_tmp_upload_id = tmp_upload_id
                    let img = Object.assign(document.createElement('img'), {
                        src: reader.result
                    })
                    
                    var new_item = document.createElement('div')
                    var span_progress = document.createElement('span')
                    new_item.setAttribute("class", "uploading-item disabled");
                    new_item.setAttribute("id", "uploading-item-" + in_tmp_upload_id);
                    span_progress.setAttribute("class", "progress");
                    span_progress.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                    new_item.appendChild(img);
                    new_item.appendChild(span_progress);
                    document.getElementById('gallery').appendChild(new_item)

                    var formData = new FormData();
                    // HTML file input, chosen by user
                    formData.append("image", file);
                    formData.append("tmp_id", in_tmp_upload_id);
                    formData.append("step", 'xhr_photo_upload');

                    axios({
                        method: 'post',
                        url: route_photo_upload,
                        data: formData,
                        onUploadProgress: function(progressEvent) {
                            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            console.log(percentCompleted)
                        }
                    })
                    .then((response) => {
                        if (response.data.success === true) {
                            
                            if(response.data.success === true) {
                                console.log(response.data)
                                document.querySelector("#uploading-item-" + in_tmp_upload_id).insertAdjacentHTML('beforebegin',
                                response.data.data);
                                document.querySelector("#uploading-item-" + in_tmp_upload_id).remove();
                                orderList(document.querySelector('.property-images-list'), document.querySelectorAll('.property-images-list .item'))
                                new Selectr("#room-choices-" + response.data.id, {
                                    nativeKeyboard: true,
                                    searchable: false,
                                });
                                reorderPhotos()
                                initDeleteBtn()
                            }
                        } else {
                            document.querySelector("#uploading-item-" + in_tmp_upload_id).remove();
                        }
                    })
                    .catch((error) => {
                        document.querySelector("#uploading-item-" + in_tmp_upload_id).remove();
                    })
                    .then(axios.spread((columnData, postData) => {
                        //this.sending = false
                    }))
                    
                });
            }
        }
    }

    function initDeleteBtn() {        
        document.querySelectorAll(".item .btn-delete").forEach(btn => {
            if (btn.getAttribute('click-listener') !== 'true')
            btn.addEventListener('click', function () {
                btn.setAttribute('click-listener', 'true');
                //btn.parentNode.parentNode.remove();
                var formData = new FormData();
                formData.append("step", 'xhr_photo_delete');
                formData.append("image", btn.getAttribute('data-id'));
                var photo_item_html = document.querySelector('.property-photo-item-' + btn.getAttribute('data-id'))
                photo_item_html.classList.add('d-none')
                orderList(document.querySelector('.property-images-list'), document.querySelectorAll('.property-images-list .item'))
                axios.post(route_photo_delete, formData)                
                    .then((response) => {
                        photo_item_html.classList.remove('d-none')
                        photo_item_html.remove()
                        orderList(document.querySelector('.property-images-list'), document.querySelectorAll('.property-images-list .item'))
                        reorderPhotos()
                    })                    
                    .catch((error) => {
                        photo_item_html.classList.remove('d-none')
                        orderList(document.querySelector('.property-images-list'), document.querySelectorAll('.property-images-list .item'))
                    })
                    .then(axios.spread((columnData, postData) => {
                        //this.sending = false
                    }))
            })
        })
    }
        

    function imageExists(url, callback) {
        var img = new Image();
        img.onload = function () {
            callback();
        };
        img.onerror = function () {};
        img.src = url;
    }

    var image_list = sortable('.property-images-list', {
        forcePlaceholderSize: true,
        orientation: 'horizontal',
        items: ':not(.disabled)'
    });

    image_list[0].addEventListener('sortupdate', function(e) {

        orderList(e.detail.destination.container, e.detail.destination.items)

        reorderPhotos()

    })

    function orderList(container, items) {

        var cover_text = container.getAttribute('data-cover-text')
        var photo_text = container.getAttribute('data-photo-text')
    
        items.forEach((item, i) => {
            if (item.classList.contains('disabled')) return;
            if (i == 0) {
                item.querySelector('.item-text').innerHTML = cover_text;
                item.querySelector('.item-text').classList.add('cover')
            } else {
                item.querySelector('.item-text').innerHTML = photo_text + " " + (i+1);
                item.querySelector('.item-text').classList.remove('cover')
            }
        });
    }
    
    function reorderPhotos() {

        var values = [];
        var inputs = dropArea.querySelectorAll("input[name='images[]']");        
        var formData = new FormData();
        formData.append("step", 'xhr_photo_reorder');
        for (i = 0; i < inputs.length; i++) {
            formData.append("images[]", inputs[i].value);
        }

        // HTML file input, chosen by user

        axios.post(route_photo_reorder, formData)
            .then((response) => {

            }, (error) => {
                //console.log(error);
            });
    }

    initDeleteBtn()
    orderList(document.querySelector('.property-images-list'), document.querySelectorAll('.property-images-list .item'))
}